import { render, staticRenderFns } from "./proformaclient_list.vue?vue&type=template&id=6b764864&"
import script from "./proformaclient_list.vue?vue&type=script&lang=js&"
export * from "./proformaclient_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports